import { createRef, useEffect, useState } from 'react';

import moment from 'moment';
import PropTypes from 'prop-types';

import { logger } from '../logger';
import StickyBanner from '../StickyBanner';
import { getAppConfig, getServiceConfig, updateSessionStorage } from '../utilities';
import { Get } from '../utilities/api-wrapper';

import './styles/index.css';

const AnnouncementHeader = ({ slug }) => {
  const [isStickyBannerClosed, setIsStickyBannerClosed] = useState(
    updateSessionStorage.getItem(`announcement-removed-${slug}`)
  );
  const [announcementData, setAnnouncementData] = useState({});

  const announcementHeader = createRef();

  const closeStickyBanner = () => {
    if (announcementHeader.current) {
      announcementHeader.current.style.height = '0px';
    }

    setIsStickyBannerClosed({
      isStickyBannerClosed: true
    });
  };

  const clearAnnouncement = () => {
    updateSessionStorage.setItem(`announcement-removed-${slug}`, true);
    closeStickyBanner();
  };

  const fetchData = async () => {
    const { lang: locale = '' } = getAppConfig('locale');
    const { url = '' } = getServiceConfig('getBanner');

    const bannerURL = `${url}?locale=${locale}&filters[slug][$eq]=${slug}`;

    try {
      const { data = [] } = await Get(bannerURL);
      if (data.length) {
        const { attributes } = data[0];
        const { onTime, offTime } = attributes;
        const timeLimit = moment(moment().format()).isBetween(onTime, offTime);
        if (!timeLimit) {
          closeStickyBanner();
          return;
        }
        setAnnouncementData(attributes);
      }
    } catch (err) {
      logger.error('Strapi API request failed', err);
    }
  };

  useEffect(() => {
    if (slug && !isStickyBannerClosed) fetchData();
  }, []);

  return !isStickyBannerClosed && Object.keys(announcementData).length ? (
    <StickyBanner
      isCloseIcon
      isFullMessage
      containerClass="announcement-banner"
      handleClick={clearAnnouncement}
      message={announcementData.message}
      color={announcementData.color || 'green'}
      isStickyBannerClosed={!!isStickyBannerClosed}
      elementRef={announcementHeader}
    />
  ) : null;
};

AnnouncementHeader.propTypes = {
  slug: PropTypes.string
};

AnnouncementHeader.defaultProps = {
  slug: ''
};

export default AnnouncementHeader;
